const newGenerateTree = (data) => {
  const tree = [];
  data.forEach((item) => {
    delete item.children;
  });
  data.forEach((item) => {
    if (item.acLevel === 1) {
      tree.push(item);
    }
  });
  data.forEach((item) => {
    if (item.acLevel === 2) {
      tree.length !== 0 &&
        tree.forEach((v) => {
          if (v.acId === item.pacId) {
            (v.children || (v.children = [])).push(item);
          }
        });
    }
  });
  data.forEach((item) => {
    if (item.acLevel === 3) {
      tree.forEach((v) => {
        if (v.children) {
          v.children.forEach((_v) => {
            if (_v.acId === item.pacId) {
              (_v.children || (_v.children = [])).push(item);
            }
          });
        }
      });
    }
  });
  return tree;
};

export default newGenerateTree;
